module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-paginator"
  }, [_c('button', {
    staticClass: "page-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.first()
      }
    }
  }, [_vm._m(0, false, false)]), _vm._v(" "), _c('button', {
    staticClass: "page-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.previous()
      }
    }
  }, [_vm._m(1, false, false)]), _vm._v(" "), _vm._l((_vm.getPageArray()), function(p) {
    return _c('button', {
      staticClass: "page-button",
      class: {
        'active-page': p.isActive
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setNewPage(p.label)
        }
      }
    }, [_vm._v("\n    " + _vm._s(p.label) + "\n  ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "page-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage === _vm.maxPage
    },
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._m(2, false, false)]), _vm._v(" "), _c('button', {
    staticClass: "page-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage === _vm.maxPage
    },
    on: {
      "click": function($event) {
        _vm.last()
      }
    }
  }, [_vm._m(3, false, false)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-chevron-double-left fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-chevron-right fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-chevron-double-right fa-fw"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7257abd7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=tqk19250jg!./~/string-replace-webpack-plugin/loader.js?id=bvfl15s0ypr!./src/components/search/SearchPaginator.vue
// module id = 702
// module chunks = 0